module.exports = { "default": require("core-js/library/fn/number/parse-float"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/babel-runtime/core-js/number/parse-float.js
// module id = 56
// module chunks = 1